export const columns = [
    {
        title: "backoffice.projects.name",
        dataIndex: "name",
        mobileLevel: 1
    },
    {
        title: "backoffice.projects.url",
        dataIndex: "url",
        mobileLevel: 2,
        render: value => {
            return (
                <span 
                    className="rt--title rt--font-normal rt--font-regular rt--table-col-link"
                    onClick={() => window.open( value,"_blank")}
                >
                    <b>{ value }</b>
                </span>
            )
        }
    },

    {
        title: "backoffice.projects.createdAt",
        dataIndex: "createdAt",
        isDateTime: true,
        mobileLevel: 3
    },
    {
        title: "backoffice.projects.createdBy",
        dataIndex: "createdBy",
        mobileLevel: 4
    },
]
